'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var theme_common_primitives_defaultPrimitives = require('../primitives/defaultPrimitives.js');
require('../primitives/commonPrimitives.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

function getFontSizesTokens(fontSizes) {
  return {
    h1: fontSizes[40],
    h2: fontSizes[32],
    h3: fontSizes[24],
    h4: fontSizes[20],
    p1: fontSizes[18],
    p2: fontSizes[16],
    p3: fontSizes[14],
    p4: fontSizes[12],
    p5: fontSizes[11],
    lb1: fontSizes[14],
    lb2: fontSizes[12],
    l1: fontSizes[14],
    /**
     * @deprecated
     */
    ln1: fontSizes[14],
    /**
     * @deprecated
     */
    ln2: fontSizes[12]
  };
}
function getFontSizes() {
  var fontSizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultFontSizePrimitives;
  return _objectSpread__default["default"](_objectSpread__default["default"]({}, fontSizes), getFontSizesTokens(fontSizes));
}
var defaultFontSizes = getFontSizes();
function getLetterSpacings() {
  var letterSpacingPrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultLetterSpacingPrimitives;
  return _objectSpread__default["default"](_objectSpread__default["default"]({}, letterSpacingPrimitives), {}, {
    standard: letterSpacingPrimitives[0],
    wide: letterSpacingPrimitives['0.5'],
    xWide: letterSpacingPrimitives['0.8']
  });
}
var defaultLetterSpacings = getLetterSpacings();
function getTypographyTokens() {
  var typographySizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFontSizes;
  var lineHeights = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : theme_common_primitives_defaultPrimitives.defaultLineHeightPrimitives;
  return {
    h1: {
      fontSize: typographySizes.h1,
      lineHeight: lineHeights[42]
    },
    h2: {
      fontSize: typographySizes.h2,
      lineHeight: lineHeights[34]
    },
    h3: {
      fontSize: typographySizes.h3,
      lineHeight: lineHeights[26]
    },
    h4: {
      fontSize: typographySizes.h4,
      lineHeight: lineHeights[22]
    },
    p1: {
      fontSize: typographySizes.p1,
      lineHeight: lineHeights[24]
    },
    p2: {
      fontSize: typographySizes.p2,
      lineHeight: lineHeights[20]
    },
    p3: {
      fontSize: typographySizes.p3,
      lineHeight: lineHeights[18]
    },
    p4: {
      fontSize: typographySizes.p4,
      lineHeight: lineHeights[14]
    },
    p5: {
      fontSize: typographySizes.p5,
      lineHeight: lineHeights[14]
    },
    lb1: {
      fontSize: typographySizes.lb1,
      lineHeight: lineHeights[18]
    },
    lb2: {
      fontSize: typographySizes.lb2,
      lineHeight: lineHeights[16]
    }
  };
}
function getAllTypography(_ref) {
  var fonts = _ref.fonts,
    fontSizePrimitives = _ref.fontSizePrimitives,
    _ref$fontWeights = _ref.fontWeights,
    fontWeights = _ref$fontWeights === void 0 ? theme_common_primitives_defaultPrimitives.defaultFontWeightPrimitives : _ref$fontWeights,
    _ref$lineHeights = _ref.lineHeights,
    lineHeights = _ref$lineHeights === void 0 ? theme_common_primitives_defaultPrimitives.defaultLineHeightPrimitives : _ref$lineHeights,
    _ref$letterSpacings = _ref.letterSpacings,
    letterSpacings = _ref$letterSpacings === void 0 ? theme_common_primitives_defaultPrimitives.defaultLetterSpacingPrimitives : _ref$letterSpacings;
  var fontSizes = getFontSizes(fontSizePrimitives);
  return {
    fonts: fonts,
    fontSizes: fontSizes,
    fontWeights: fontWeights,
    lineHeights: lineHeights,
    letterSpacings: getLetterSpacings(letterSpacings),
    typography: getTypographyTokens(fontSizes, lineHeights)
  };
}

exports.defaultFontSizes = defaultFontSizes;
exports.defaultLetterSpacings = defaultLetterSpacings;
exports.getAllTypography = getAllTypography;
exports.getFontSizes = getFontSizes;
exports.getFontSizesTokens = getFontSizesTokens;
exports.getLetterSpacings = getLetterSpacings;
exports.getTypographyTokens = getTypographyTokens;
//# sourceMappingURL=typography.js.map
